// extracted by mini-css-extract-plugin
export default {"input":"PhoneNumberInput_input__M8M1Z"};